export default __webpack_public_path__ + "static/media/sowmz-lop-crop.00e0d6c4.jpg";